<template>
  <div class="row">
    <div class="col">
      <alert v-if="isError" type="danger"></alert>
      <alert v-if="isMessage" type="primary"></alert>
      <div class="auth-flow">
        <div v-if="isRegistering" class="register">
          <register></register>
          <b-form-group style="text-align: right">
            <button @click="signUpToggle" class="btn btn-link sign-in-toggle" style="margin-right: 0px">Already
              registered? Sign In</button>
          </b-form-group>
        </div>
        <div v-if="forgotPasswordForm">
          <b-form @submit="handleForgotPasswordSubmit">
            <h3 v-bind:style="{ marginTop: '11px' }">Reset your password</h3>
            <hr style="border-color: #000302; margin-top: 15px; margin-bottom: 20px" />
            <p>Enter your email address to reset your password.</p>
            <b-form-group label="Email" label-for="email">
              <b-form-input type="text" v-model="form.email" id="email" placeholder="you@example.com"
                required></b-form-input>
            </b-form-group>
            <b-form-group style="text-align: right;">
              <button :disabled="form.email === '' || isSendingEmail" type="submit"
                class="btn arrow-btn-primary btn-inverse text-right"><div>Send Password Reset</div></button>
            </b-form-group>
          </b-form>
          <b-form-group style="text-align: right;">
            <button @click="toggleForgotPasswordForm" class="btn btn-link" style="margin-right: 0px">Sign In
              Instead</button>
          </b-form-group>
        </div>
        <div v-if="forgotPassword">
          <b-form @submit="handleChangePasswordSubmit">
            <h3 v-bind:style="{ marginTop: '11px' }">Change your password</h3>
            <hr style="border-color: #000302; margin-top: 15px; margin-bottom: 20px" />
            <p>Create a new password.</p>
            <b-form-group label="Password" label-for="password">
              <b-form-input type="password" v-model="form.password" id="password" required></b-form-input>
            </b-form-group>
            <b-form-group label="Retype Password" label-for="password">
              <b-form-input type="password" v-model="form.retypePassword" id="password-retype" required></b-form-input>
            </b-form-group>
            <b-form-group>
              <button :disabled="!isSamePassword" type="submit" class="btn arrow-btn-primary btn-inverse"><div>Reset Password</div></button>
            </b-form-group>
          </b-form>
        </div>
        <div v-if="!isRegistering && !forgotPasswordForm && !forgotPassword" class="login">
          <b-form class="login-content" @submit="handleSubmit">
            <h3 v-bind:style="{ marginTop: '11px' }">Sign in</h3>
            <hr style="border-color: #D2C5B2; margin-top: 15px; margin-bottom: 20px" />
            <b-form-group label="Email" label-for="email">
              <b-form-input type="text" v-model="form.email" id="email" placeholder="you@example.com"
                required></b-form-input>
            </b-form-group>
            <b-form-group label="Password" label-for="password">
              <b-form-input type="password" v-model="form.password" id="password" required></b-form-input>
            </b-form-group>
            <b-form-group style="text-align: right;">
              <button :disabled="disabled" type="submit" class="btn arrow-btn-primary float-right"><div>Login</div></button>
              <p class="text-right mt-2" v-if="isLoggingIn">Logging In...</p>
            </b-form-group>
            <b-form-group style="text-align: right;">
              <div style="display: flex;column-gap: 10px;justify-content: end;">
              <button @click="toggleForgotPasswordForm" type="button" class="btn btn-link">Forgot your password?</button>
              <button @click="signUpToggle" type="button" class="btn btn-link">Don't have an
                account? Sign up</button>
              </div>
            </b-form-group>
            <!-- <b-form-group>
                <a href="http://s2021.siggraph.org/conference/conference-overview/student-volunteers/student-volunteers-submissions" target="_blank">Frequently Asked Questions</a>
              </b-form-group> -->
          </b-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Alert from '@/components/Alert'
import Register from '@/components/user/Register'

export default {
  name: 'Login',
  props: {
    isRegistering: Boolean
  },
  data () {
    return {
      isLoggingIn: false,
      isSendingEmail: false,
      forgotPasswordForm: false,
      form: {
        email: '',
        password: '',
        retypePassword: ''
      }
    }
  },
  computed: {
    ...mapGetters(['isError', 'isMessage', 'isBeforeDeadline']),
    ...mapState('user', ['forgotPassword']),
    disabled: function () {
      if (this.form.email === '' ||
        this.form.password === '' ||
        this.isLoggingIn) {
        return true
      }
      return false
    },
    isSamePassword: function () {
      return this.form.password !== '' && this.form.retypePassword !== '' && this.form.password === this.form.retypePassword
    }
  },
  methods: {
    signUpToggle () {
      this.$emit('toggle')
    },
    handleSubmit (e) {
      e.preventDefault()
      this.isLoggingIn = true
      this.$store.dispatch('user/login', this.form)
        .then(() => {
          this.isLoggingIn = false
        })
        .catch(err => {
          this.isLoggingIn = false
          console.log(err.message)
        })
    },
    handleForgotPasswordSubmit (e) {
      e.preventDefault()
      this.isSendingEmail = true
      this.$store.dispatch('user/forgotPassword', this.form.email)
        .then(() => {
          this.forgotPassword = false
          this.isSendingEmail = false
        }).catch(err => {
          console.log(err.message)
          this.forgotPassword = false
          this.isSendingEmail = true
        })
    },
    handleChangePasswordSubmit (e) {
      e.preventDefault()
      this.isLoggingIn = true
      this.$store.dispatch('user/changePassword', { password: this.form.password, retypePassword: this.form.retypePassword })
        .then(() => {
          this.isLoggingIn = false
        })
        .catch(err => {
          this.isLoggingIn = false
          console.log(err.message)
        })
    },
    toggleForgotPassword: function () {
      this.forgotPassword = !this.forgotPassword
    },
    toggleForgotPasswordForm: function () {
      this.forgotPasswordForm = !this.forgotPasswordForm
    }
  },
  components: {
    alert: Alert,
    register: Register
  },
  created () {
    if (this.$store.state.user.changedPassword) {
      this.$store.commit('message', {
        message: 'Password successfully changed.'
      })
      // This will reinitialize all user data
      this.$store.commit('user/logout')
    }
  }
}
</script>

<!-- <style lang="scss">
@import "../../assets/scss/Auth.scss";
</style> -->



// WEBPACK FOOTER //
// src/components/user/Login.vue